import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  eventMap: {
    width: "120px",
    [theme.breakpoints.down("md")]: {
      width: "70px",
      fontSize: theme.spacing(1.75),
      padding: theme.spacing(0.5),
      whiteSpace: "normal",
    },
    whiteSpace: "nowrap",
    height: "55px",
    borderLeft: `1px solid ${theme.palette.border.default}`,
    borderRadius: 0,
    padding: theme.spacing(1),
    textDecoration: "none",
    color: theme.palette.text.primary,
    "&:hover": {
      textDecoration: "none",
    },
  },
  rightBorder: { borderRight: `1px solid ${theme.palette.border.default}` },
  menuPopover: {
    marginTop: "52px",
    width: "fit-content",
    border: `1px solid ${theme.palette.border.default}`,
    borderRadius: "8px",
    boxShadow: "none",
    maxWidth: "650px",
    minWidth: "400px",
    [theme.breakpoints.down("md")]: {
      left: "0px !important",
    },
  },
  headerContainer: {
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
    borderBottom: `1px solid ${theme.palette.border.default}`,
  },
  closeButton: {
    cursor: "pointer",
    color: theme.palette.icon.primary,
  },
  cardsContainer: {
    maxHeight: "315px",
    overflow: "auto",
  },
}));
